/* eslint-disable prettier/prettier */
import { useState, useEffect } from 'react';
import * as React from 'react';
import { ISelectListItem, IPurchasedService } from '../../Common/types';
import Fetcher from "../../Common/Fetch"
import BuyTariff from "../../Shared/BuyTariff";
import { fetcherPOSTJSON, fetcherGET } from "../../Common/Fetch";

interface IPropsType {
    ProjectsDictionary: string;
    ActiveServiceName: string;
    ActiveOrderId: string;
}

function TariffsList(props: IPropsType) {  

    const [isOpen, setIsOpen] = useState(false);
    const [activeOption, setActiveOption] = useState();
    const [projects, setProjects] = useState(JSON.parse(props.ProjectsDictionary));
    const [isBuyPopup, setIsBuyPopup] = useState(false);

    useEffect(() => {
        fetcherGET('/OrderServiceApi/GetPurchasedServicesByAccountId?accountId=1843', (result) => {
            console.log(result);
        })

        console.log(JSON.parse(props.ProjectsDictionary));
        console.log('Данные об активной тарифе:' + ' ' + props.ActiveOrderId + ' ' + props.ActiveServiceName)
    }, [])

    const close = () => { setIsBuyPopup(false) };

    return (
        <>
            <h4 className="purpleTextHead">Тарифный план</h4>
            <div className="tariffs">
                <div className="tariffCard active">
                    <div className="tariffTitle">
                        <h4>Стартовый</h4>
                        <div className="tariffPrice">
                            <span>0</span>
                            <p>₽/мес</p>
                        </div>
                    </div>

                    <hr className="stroke"></hr>

                    <div className="tariffDescription">
                        <div className="item">
                            <h4>15%</h4>
                            <p>вознаграждение при успешных торгах VIOMITRA выплачивает продавцу из своей комиссии</p>
                        </div>
                        <div className="item">
                            <h4>2%</h4>
                            <p>от цены лота оплачивает победитель торгов при успешной сделке</p>
                        </div>
                        <div className="item">
                            <h4>5</h4>
                            <p>лотов для размещения</p>
                        </div>
                        <div className="item">
                            <h4>1 000 ₽</h4>
                            <p>стоимость одного размещения</p>
                        </div>
                    </div>
                </div>

                <div className="tariffCard">
                    <div className="tariffTitle">
                        <h4>Основной</h4>
                        <div className="tariffPrice">
                            <span>2000</span>
                            <p>₽/мес</p>
                        </div>
                    </div>

                    <hr className="stroke"></hr>

                    <div className="tariffDescription">
                        <div className="item">
                            <h4>15%</h4>
                            <p>вознаграждение при успешных торгах VIOMITRA выплачивает продавцу из своей комиссии</p>
                        </div>
                        <div className="item">
                            <h4>2%</h4>
                            <p>от цены лота оплачивает победитель торгов при успешной сделке</p>
                        </div>
                        <div className="item">
                            <h4>15</h4>
                            <p>лотов для размещения</p>
                        </div>
                        <div className="item">
                            <h4>850 ₽</h4>
                            <p>стоимость одного размещения</p>
                        </div>
                        <div className="item">
                            <h4>2 000 MI</h4>
                            <p>на оплату услуг продвижения</p>
                        </div>
                    </div>
                    <span className="defaultPinkButton" onClick={() => { setIsBuyPopup(true) }}>Заказать</span>
                </div>

                <div className="tariffCard">
                    <div className="tariffTitle">
                        <h4>Бизнес</h4>
                        <div className="tariffPrice">
                            <span>4000</span>
                            <p>₽/мес</p>
                        </div>
                    </div>

                    <hr className="stroke"></hr>

                    <div className="tariffDescription">
                        <div className="item">
                            <h4>15%</h4>
                            <p>вознаграждение при успешных торгах VIOMITRA выплачивает продавцу из своей комиссии</p>
                        </div>
                        <div className="item">
                            <h4>2%</h4>
                            <p>от цены лота оплачивает победитель торгов при успешной сделке</p>
                        </div>
                        <div className="item">
                            <h4>30</h4>
                            <p>лотов для размещения</p>
                        </div>
                        <div className="item">
                            <h4>650 ₽</h4>
                            <p>стоимость одного размещения</p>
                        </div>
                        <div className="item">
                            <h4>4 000 MI</h4>
                            <p>на оплату услуг продвижения</p>
                        </div>
                        <div className="item">
                            <h4 className="buisiness">Доступ к закрытым продажам и инвестиционному бутику</h4>
                        </div>
                    </div>
                    <span className="defaultPinkButton" onClick={() => {setIsBuyPopup(true)}}>Заказать</span>
                </div>
            </div>

            <div className="formWrapper switchProject">
                <h5 className="purpleTextHeadSmall">Перенести активную услугу на другой проект:</h5>
                <div className="inputWrapper">
                    <div className={isOpen ? "customSelect2 open" : "customSelect2"}>
                        <div className="activeOption" onClick={() => { setIsOpen(!isOpen) }}>
                            {activeOption ? activeOption : 'Выберите проект'}
                            <svg style={{ transform: isOpen ? 'rotate(180deg)' : '' }} xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                                <path d="M5.19205 5.76856L8.90654 1.31117C9.34076 0.790108 8.97024 -0.000977755 8.29197 -0.000977755L1.70803 -0.000977755C1.02976 -0.000977755 0.659236 0.790107 1.09345 1.31117L4.80794 5.76856C4.90789 5.8885 5.09211 5.8885 5.19205 5.76856Z" fill="#170021" />
                            </svg>
                        </div>
                        <div className="options">
                            {Object.keys(projects).map((key) =>
                                <p className={key} onClick={() => {
                                    setActiveOption(projects[key])
                                    setIsOpen(false)
                                }}>{projects[key]}</p>
                            )}
                        </div>
                    </div>

                    <button type="button" className="defaultPinkButton">
                        Выполнить перенос
                    </button>
                </div>
            </div>

            {isBuyPopup &&
                <BuyTariff close={close} />    
            }
        </>
    )
}

export default TariffsList;


    